import appStore from 'store';
import api from './api';
const store = {
  namespaced: true,
  state: {
    projects: [],
    coinTypeList: [],
    editingProject: null
  },
  getters: {},
  mutations: {
    setList(state, payload) {
      state.projects = payload;
    },
    setCoinTypeList(state, payload) {
      state.coinTypeList = payload;
    },
    setEditingProject(state, payload) {
      state.editingProject = payload;
    }
  },
  actions: {
    getList({ commit }, query) {
      api.getList(query).then(({ data }) => {
        commit('setList', data);
      });
    },
    update(context, data) {
      return api.update(data);
    },
    remove(context, data) {
      return api.remove(data);
    },
    getCoinTypeList({ commit }) {
      api.getCoinTypeList().then(({ data }) => {
        commit('setCoinTypeList', data);
      });
    },
    create(context, data) {
      return api.createCycle(data);
    }
  }
};

appStore.registerModule('cycle', store);
